import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import {
  makeBackendAPIRequest,
  backendBaseURL,
} from "../api_utilities/backend";
import { makeSpotifyAPIRequest } from "../api_utilities/spotify";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";

const useStyles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    height: "100%",
  },
  spaceBelow: {
    marginBottom: theme.spacing(2),
  },
});

class Admin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      snackbarMessage: "",
      isSnackbarOpen: false,
      snackbarSeverity: "success",
    };
  }

  addSongAndTagMetadata = () => {
    const url = new URL(
      backendBaseURL + "/song/get_all_songs_and_tags_for_metadata_fix"
    );
    makeBackendAPIRequest({
      url: url,
      method: "GET",
      onSuccessCallback: (data) => {
        const processBatch = (itemsSlice, callbackURL) => {
          const url = new URL(`https://api.spotify.com/v1/tracks`);
          url.searchParams.append(
            "ids",
            itemsSlice.map((item) => item.id_spotify).join(",")
          );

          makeSpotifyAPIRequest({
            url: url,
            method: "GET",
            onSuccessCallback: (data) => {
              const tracks = data.tracks;
              const bySpotifyID = new Map(
                tracks.map((track) => [
                  track.id,
                  {
                    song_name: track.name,
                    duration_ms: track.duration_ms,
                    track_number: track.track_number,
                  },
                ])
              );

              const song_infos = itemsSlice
                .map((songRating) => {
                  const spotifyTrack = bySpotifyID.get(songRating.id_spotify);
                  if (!spotifyTrack) return null;
                  return { ...songRating, ...spotifyTrack };
                })
                .filter(Boolean);

              makeBackendAPIRequest({
                url: callbackURL,
                method: "POST",
                body: { song_infos: JSON.stringify(song_infos) },
                onSuccessCallback: () => {
                  this.setState({
                    snackbarOpen: true,
                    snackbarMessage: "Updated metadata in backend for batch",
                    snackbarSeverity: "success",
                  });
                },
                onFailureCallback: () => {
                  this.setState({
                    snackbarOpen: true,
                    snackbarMessage: "Failed to update tag metadata in backend",
                    snackbarSeverity: "warning",
                  });
                },
              });
            },
            onFailureCallback: () => {
              this.setState({
                snackbarOpen: true,
                snackbarMessage: "Failed to fetch tracks from spotify",
                snackbarSeverity: "warning",
              });
            },
          });
        };

        const executeBatchRecursive = (
          items,
          i,
          batchSize,
          callbackURL,
          delayms,
          doneFn
        ) => {
          const numItems = items.length;
          if (i >= numItems) {
            doneFn();
            return;
          }

          const slice = items.slice(i, i + batchSize);
          processBatch(slice, callbackURL);
          setTimeout(() => {
            executeBatchRecursive(
              items,
              i + batchSize,
              batchSize,
              callbackURL,
              delayms,
              doneFn
            );
          }, delayms);
        };

        // const ratings = data.ratings;
        // executeBatchRecursive(
        //   ratings,
        //   0,
        //   50,
        //   new URL(backendBaseURL + "/song/update_song_metadata"),
        //   3000,
        //   () => {
        //     const tags = data.tags;
        //     executeBatchRecursive(
        //       tags,
        //       0,
        //       50,
        //       new URL(backendBaseURL + "/song/update_tag_metadata"),
        //       3000,
        //       () => {
        //         this.setState({
        //           snackbarOpen: true,
        //           snackbarMessage: "Successfully updated all songs and tags",
        //           snackbarSeverity: "success",
        //         });
        //       }
        //     );
        //   }
        // );

        const tags = data.tags;
        executeBatchRecursive(
          tags,
          0,
          50,
          new URL(backendBaseURL + "/song/update_tag_metadata"),
          3000,
          () => {
            this.setState({
              snackbarOpen: true,
              snackbarMessage: "Successfully updated all songs and tags",
              snackbarSeverity: "success",
            });
          }
        );
      },
      onFailureCallback: () => {
        this.setState({
          snackbarOpen: true,
          snackbarMessage: "Failed to fetch all songs and tags",
          snackbarSeverity: "warning",
        });
      },
    });
  };

  render() {
    const { classes } = this.props;
    const { snackbarMessage, isSnackbarOpen, snackbarSeverity } = this.state;

    return (
      <Card className={classes.root}>
        <Grid container spacing={3}>
          <Grid
            item
            container
            xs={12}
            justify={"flex-end"}
            className={classes.spaceBelow}
          >
            <Typography variant="overline">Admin</Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.addSongAndTagMetadata}
            >
              Fix Song and Tag Metadata
            </Button>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={isSnackbarOpen}
          autoHideDuration={snackbarMessage.length * 150}
          onClose={() => {
            this.setState({ isSnackbarOpen: false });
          }}
        >
          <Alert
            onClose={() => {
              this.setState({ isSnackbarOpen: false });
            }}
            severity={snackbarSeverity}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Card>
    );
  }
}

export default withStyles(useStyles)(Admin);
